import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Divider} from 'shells/layout/divider';
import {FormattedTimestamp} from 'shells/timestamp/formatted-timestamp';

import styles from './entity-list-title-bar.module.css';

export type Props = {
    visibility?: string;
    description: string | null | undefined;
    creatorUserName: string | null | undefined;
    createdTime: number;
};

export function SubheaderPrimaryText(props: Props) {
    return (
        <span className='flex align-center'>
            {props.visibility && (
                <>
                    {props.visibility}
                    <Divider variant='dot' spacing={4} color={colors.greyLt} />
                </>
            )}
            {props.description && (
                <>
                    <span className={styles['description-container']} title={props.description}>
                        {props.description}
                    </span>
                    <Divider variant='dot' spacing={4} color={colors.greyLt} />
                </>
            )}
            {props.creatorUserName && <>{`Created by ${props.creatorUserName} on\u00A0`}</>}
            <FormattedTimestamp
                datetime={props.createdTime}
                format={FormattedTimestamp.formats.longMonthDayWithYear}
            />
        </span>
    );
}
